import { NotificationService } from '../../core/service/notifications/notification.service';
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-toast-popup',
  templateUrl: './toast-popup.component.html',
  styleUrls: ['./toast-popup.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0,
        transform: 'translateX(-50%) translateY(-100%)'
      })),
      transition(':enter', [
        animate('500ms cubic-bezier(0.34, 1.56, 0.64, 1)',
          style({ opacity: 1, transform: 'translateX(-50%) translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-out',
          style({ opacity: 0, transform: 'translateX(-50%) translateY(-50%)' }))
      ])
    ])
  ]
})
export class ToastPopupComponent implements OnInit {
  isVisible = false;
  status: 'success' | 'error' = 'success';
  message = '';

  get icon(): string {
    return this.status === 'success' ? '✔' : '✖';
  }

  get statusClass(): string {
    return this.status === 'success' ? 'success' : 'error';
  }

  constructor(private notificationService: NotificationService) { }

  ngOnInit() {
    this.notificationService.notifications.subscribe(notification => {
      this.status = notification.status;
      this.message = notification.message;
      this.show();
    });
  }

  show() {
    this.isVisible = true;
    setTimeout(() => this.hide(), 3000);
  }

  hide() {
    this.isVisible = false;
  }
}
